/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Lastname_Label1Inputs */

const en_onboarding_lastname_label1 = /** @type {(inputs: Onboarding_Lastname_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last name`)
};

const fr_onboarding_lastname_label1 = /** @type {(inputs: Onboarding_Lastname_Label1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nom de famille`)
};

/**
* | output |
* | --- |
* | "Last name" |
*
* @param {Onboarding_Lastname_Label1Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const onboarding_lastname_label1 = /** @type {((inputs?: Onboarding_Lastname_Label1Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Lastname_Label1Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_lastname_label1(inputs)
	return fr_onboarding_lastname_label1(inputs)
});
export { onboarding_lastname_label1 as "onboarding_lastName_label" }